__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "eupApp";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@angular/common/http", "17.3.2", () => (() => (__webpack_require__(77008))), 1);
			register("@angular/common", "17.3.2", () => (() => (__webpack_require__(39191))), 1);
			register("@angular/core/primitives/signals", "17.3.2", () => (() => (__webpack_require__(96346))), 1);
			register("@angular/core/rxjs-interop", "17.3.2", () => (() => (__webpack_require__(48065))), 1);
			register("@angular/core", "17.3.2", () => (() => (__webpack_require__(96623))), 1);
			register("@angular/router", "17.3.2", () => (() => (__webpack_require__(17660))), 1);
			register("@itero/assets-bff-sdk", "1.0.0-dev.189.53", () => (() => (__webpack_require__(60959))), 1);
			register("@itero/auth-angular", "17.0.3", () => (() => (__webpack_require__(15959))), 1);
			register("@ngx-translate/core", "14.0.0", () => (() => (__webpack_require__(97634))), 1);
			register("ngx-bootstrap/modal", "12.0.0", () => (() => (__webpack_require__(3749))), 1);
			register("ngx-toastr", "18.0.0", () => (() => (__webpack_require__(63404))), 1);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};